export default __webpack_public_path__ + "static/media/mx.b2ba7a3b.svg";